import { ReactNode } from 'react';
import PeriodBar, { PeriodInfo } from './PeriodBar';
import { StatisticsFilters, filtersToSearch } from '../../utils/period';
import './Statistics.css';

interface StatisticsPageProps {
  title: string;
  subtitle: string;
  filters: StatisticsFilters;
  onFiltersChange: (next: Partial<StatisticsFilters>) => void;
  period?: PeriodInfo | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  showComparison?: boolean;
  children?: ReactNode;
}

/** The frame every statistics screen shares: heading, filters, loading and error states. */
const StatisticsPage = ({
  title,
  subtitle,
  filters,
  onFiltersChange,
  period,
  loading,
  error,
  onRetry,
  showComparison,
  children,
}: StatisticsPageProps) => (
  <div className="stats-page">
    <div className="stats-page-header">
      <div>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </div>
    <PeriodBar filters={filters} onChange={onFiltersChange} period={period} showComparison={showComparison} />
    {error && (
      <div className="stats-error" role="alert">
        <span>{error}</span>
        <button type="button" className="stats-button" onClick={onRetry}>
          Retry
        </button>
      </div>
    )}
    {loading && !error && <p className="stats-loading">Loading…</p>}
    {!loading && !error && children}
  </div>
);

/** Link to the rows behind a figure, keeping the current filters. */
export const drilldownPath = (metric: string, filters: StatisticsFilters) =>
  `/statistics/drilldown/${metric}?${filtersToSearch(filters)}`;

/** Link to the member's row in People. */
export const personPath = (userId: number) => `/users?search=${encodeURIComponent(`#${userId}`)}`;

export default StatisticsPage;
